<template>
  <li
    role="option"
    :aria-selected="active ? 'true' : 'false'"
    class="company-switcher__option"
    :class="{ 'is-selected': selected, 'is-active': active }"
  >
    <span class="company-switcher__option-label">{{ label }}</span>
    <template v-if="selected">
      <lucide-icon
        :icon="icons.check"
        :size="16"
        aria-hidden="true"
        class="company-switcher__option-check"
      />
      <span class="sr-only">{{ $t('empresaatual') }}</span>
    </template>
  </li>
</template>

<script>
import { Check } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'CompanySwitcherOption',
  components: { LucideIcon },
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icons() {
      return { check: Check }
    }
  }
}
</script>
